// extracted by mini-css-extract-plugin
export default {"installButton":"styles_installButton__YcozT","wrapper":"styles_wrapper__ME3K9","icon":"styles_icon__s7bu-","version":"styles_version__KHKlp"};